import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType";
import { ImageFormats } from "../../../components/finalForms/libs/data/imageFormatTypes";
import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes";

const initState = {
  organizationLogo: ''
}

export const organizationFormData = {
  name: "Organization  Form",
  initialState: initState,

  section: [
    {
      sectionId: 'basicDetailSection',
      title: "Organization Profile Section",
      row: {},
      style: {
        sectionStyle: "mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "Organization",
          Field_Name: "organization logo",
          fieldType: FormFieldTypes.IMAGE,
          dataField: "organizationLogo",
          fieldSetting: {
            placeholder: "Upload Organization Logo",
            allowMultipleImage: false,
            imageUpload: true,
            isDownloadable: false,
            minImageSizeInMB: 0,
            maxImageSizeInMB: 8,
            acceptedImageFormats: [ImageFormats.ANY]
          },
          validation: [{ type: validationTypes.IMAGE }],
          style: {
            containerCss: "col-md-3 mb-2 file-upload-container org-img-uploader",
          },
        },
      ]
    }
  ]
}
